import * as React from 'react';
import styled from 'styled-components';

// ############################ Imported from Old UI ###########################

export interface ITitleProps {
  tabIndexProp?: number;
  dataAt?: string;
  dataTestId?: string;
  alignLeft?: boolean;
  className?: string;
}

// tslint:disable-next-line:variable-name
const StyledTitle = styled.h1<{ alignLeft }>(
  ({ theme, alignLeft }) => `
    font-family: 'Poppins';
    font-size: ${theme.font.size.medium3};
    line-height: 30px;
    font-weight: 550;
    color: ${theme.colors.primaryBackground};
    margin-bottom: ${theme.spacing.mediumLarger}px;
    text-align: ${alignLeft ? 'left' : 'center'};
    @media only screen and (min-width: 1024p) {
      margin: 0 0 90px;
    }
    @media only screen and (max-width: 1024px) {
      margin: 10px 0 10px 0;
    }
  `
);

export default class Title extends React.Component<ITitleProps> {
  public render() {
    const { dataTestId } = this.props;
    return (
      <StyledTitle
        className={this.props.className}
        alignLeft={this.props.alignLeft}
        tabIndex={this.props.tabIndexProp || 0}
        data-at={this.props.dataAt ? this.props.dataAt : 'infoHeaderTxt'}
        data-testid={dataTestId}
      >
        {this.props.children}
      </StyledTitle>
    );
  }
}
